import { isTokenValid } from './session';

export type OfflineSyncGate = 'sync' | 'login' | 'stay-offline';

// Coming back online with an expired cached token must show login before any sync.
// While offline, an expired token must not log the field user out.
export const offlineSyncGate = (online: boolean, token: string | null | undefined): OfflineSyncGate => {
  if (!online) return 'stay-offline';
  if (!isTokenValid(token || null)) return 'login';
  return 'sync';
};

// The logout mutation only writes login metadata. The device session still ends when this is false.
export const shouldRecordLogoutOnServer = (online: boolean) => online;

export const shouldLogoutForExpiredSession = (
  online: boolean,
  landingPage: boolean,
  tokenStillValid: boolean,
  hasToken: boolean
) => {
  if (!online || landingPage) return false;
  return !tokenStillValid || !hasToken;
};
